import { StoreTimesale } from 'types/storeTimesale'

export const FETCH_STORE_TIMESALE = 'FETCH_STORE_TIMESALE'
export const fetchStoreTimesaleAction = (storeTimesale: StoreTimesale) => {
  return {
    type: 'FETCH_STORE_TIMESALE',
    payload: storeTimesale,
  }
}

export const INIT_STORE_TIMESALE = 'INIT_STORE_TIMESALE'
export const initStoreTimesaleAction = () => {
  return {
    type: 'INIT_STORE_TIMESALE',
    payload: null,
  }
}
